import React from 'react';
import { Instagram, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-logo-navy text-white py-12 px-4 border-t-4 border-logo-teal">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_nostalgic-shots-14/artifacts/vuwy1zic_unnamed.jpg"
                alt="Vintage Camera Box Logo"
                className="h-16 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Creating lasting memories with our digital photo booth experience. Perfect for weddings, parties, and corporate events.
            </p>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-4">Get In Touch</h4>
            <ul className="space-y-3 text-white/70 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-logo-teal" />
                <a href="mailto:vintagecamerabox@gmail.com" className="hover:text-logo-teal transition-colors">
                  vintagecamerabox@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="w-5 h-5 text-logo-teal" />
                <a href="https://instagram.com/vintagecamerabox" target="_blank" rel="noopener noreferrer" className="hover:text-logo-teal transition-colors">
                  @VintageCameraBox
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-logo-teal" />
                <span>Delivery within 20 miles</span>
              </li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>
                <a href="#features" className="hover:text-logo-teal transition-colors">Features</a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-logo-teal transition-colors">Pricing</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-logo-teal transition-colors">Contact</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-logo-teal/30 mt-12 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Vintage Camera Box. All rights reserved. Creating memories, one snapshot at a time.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;